import { BloodPressure } from "./BloodPressure/index";
import { HeartRate } from "./HeartRate/index";
import { RespirationFrequency } from "./RespirationFrequency/index";
import { Temperature } from "./Temperature/index";
import { OxygenSaturation } from "./OxygenSaturation/index";

export const VitalSigns = {
	BloodPressure,
	HeartRate,
	RespirationFrequency,
	Temperature,
	OxygenSaturation,
};
